export default function DialogContentText(theme) {
	return {
		MuiDialogContentText: {
			styleOverrides: {
				root: {}
			}
		}
	};
}
